// extracted by mini-css-extract-plugin
export default {"base":"ProgressBar_base__t3JNC","label":"ProgressBar_label__ZdKwF","trail":"ProgressBar_trail__iR+2h","bar":"ProgressBar_bar__wcd5w","visible":"ProgressBar_visible__zM9wm"};